import { render } from "./ny-system-users-grid.vue?vue&type=template&id=3508a896"
import script from "./ny-system-users-grid.vue?vue&type=script&lang=js"
export * from "./ny-system-users-grid.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__